import * as constants from './constants'

export const setComps = data => ({
  type: constants.SET_COMPS.ACTION,
  payload: data
})

export const getComps = () => ({
  type: constants.GET_COMPS.ACTION
})

export const resetComps = () => ({
  type: constants.RESET_COMPS.ACTION
})

export const updateComps = data => ({
  type: constants.UPDATE_COMPS.ACTION,
  payload: data
})

export const clearComps = () => ({
  type: constants.CLEAR_COMPS.ACTION
})

export const deleteProperty = data => ({
  type: constants.DELETE_PROPERTY.ACTION,
  payload: data
})

export const downloadPdf = () => ({
  type: constants.DOWNLOAD_PDF_S3.ACTION
})

export const acknowledgeLastSuccessful = () => ({
  type: constants.ACKNOWLEDGE_LAST_SUCCESSFUL_NETWORK
})

export const reArrangeComps = ({ indexFrom, indexTo, propertyType }) => ({
  type: constants.RE_ARRANGE_COMPS.ACTION,
  payload: { indexFrom, indexTo, propertyType }
})

export const editUnitMixData = ({ comparableData, propertyType, unitMixDisclaimerData }) => ({
  type: constants.EDIT_UNITMIX_DATA.ACTION,
  payload: { comparableData, propertyType, unitMixDisclaimerData }
})

export const toggleFeature = payload => ({
  type: constants.TOGGLE_FEATURE.ACTION,
  payload
})

export const editFeature = payload => ({
  type: constants.EDIT_FEATURE.ACTION,
  payload
})

export const editBarChartSettings = payload => ({
  type: constants.BAR_CHART_SETTINGS.ACTION,
  payload
})

export const editFloorPlanBarChartSettings = payload => ({
  type: constants.FP_BAR_CHART_SETTINGS.ACTION,
  payload
})

export const editDonutChartColors = payload => ({
  type: constants.EDIT_DONUTCHART_COLORS.ACTION,
  payload
})

export const editFileName = payload => ({
  type: constants.EDIT_FILE_NAME.ACTION,
  payload
})

export const editThemeColors = payload => ({
  type: constants.THEME_COLOR_SETTINGS.ACTION,
  payload
})

export const editPropertyDetails = payload => ({
  type: constants.EDIT_PROPERTY_DETAILS.ACTION,
  payload
})

export const editColumnsDetails = payload => ({
  type: constants.EDIT_COLUMNS_DETAILS.ACTION,
  payload
})

export const isPopupDialogOpen = payload => ({
  type: constants.SHOW_POPUP_DIALOG.ACTION,
  payload
})

export const getProjectById = payload => ({
  type: constants.GET_PROJECT_BY_ID.ACTION,
  payload
})

export const getCompsOffices = () => ({
  type: constants.GET_OFFICES.ACTION
})

export const saveCompsProject = payload => ({
  type: constants.SAVE_COMPS_PROJECT.ACTION,
  payload
})

export const getRecentProjects = () => ({
  type: constants.GET_RECENT_PROJECTS.ACTION
})

export const updateCompsProject = payload => ({
  type: constants.UPDATE_COMPS_PROJECT.ACTION,
  payload
})

export const searchProjects = () => ({
  type: constants.SEARCH_PROJECTS.ACTION
})

export const getAllProjects = () => ({
  type: constants.GET_ALL_PROJECTS.ACTION
})

export const setPagination = payload => ({
  type: constants.SET_PAGINATION.ACTION,
  payload
})

export const setRecentPagination = payload => ({
  type: constants.SET_RECENT_PAGINATION.ACTION,
  payload
})

export const setMapsPagination = payload => ({
  type: constants.SET_MAPS_PAGINATION.ACTION,
  payload
})

export const deleteProject = payload => ({
  type: constants.DELETE_PROJECT.ACTION,
  payload
})

export const loadRegions = () => ({
  type: constants.LOAD_REGIONS.ACTION
})

export const setTotalProjectsText = payload => ({
  type: constants.SET_TOTAL_PROJECTS_TEXT.ACTION,
  payload
})

export const setProjectAsFavorite = payload => ({
  type: constants.SET_PROJECT_AS_FAVORITE.ACTION,
  payload
})

export const getCities = payload => ({
  type: constants.GET_CITIES.ACTION,
  payload
})

export const getUsers = payload => ({
  type: constants.GET_USERS.ACTION,
  payload
})

export const editPropertyName = payload => ({
  type: constants.EDIT_PROPERTY_NAME.ACTION,
  payload
})

export const getPropertyInfo = omniViewPropertyId => ({
  type: constants.GET_PROPERTY_INFO.ACTION,
  payload: { omniViewPropertyId }
})

export const getPropertyInfoBySource = source => ({
  type: constants.GET_PROPERTY_INFO_BY_SOURCE.ACTION,
  payload: { source }
})

export const getListInfo = payload => ({
  type: constants.GET_LIST_INFO.ACTION,
  payload
})

export const createProjectFromList = payload => ({
  type: constants.CREATE_PROJECT_FROM_LIST.ACTION,
  payload
})

export const resetSelectedListInfo = payload => ({
  type: constants.RESET_SELECTED_LIST_INFO.ACTION,
  payload
})

export const refreshListInfo = selectedRefreshOption => ({
  type: constants.REFRESH_LIST_INFO.ACTION,
  payload: { selectedRefreshOption }
})

export const togglePropertyWeightedAvg = payload => ({
  type: constants.TOGGLE_PROPERTY_WEIGHTED_AVG.ACTION,
  payload
})

export const setTabIndex = payload => ({
  type: constants.SET_TAB_INDEX.ACTION,
  payload
})

export const getMapProjects = () => ({
  type: constants.GET_MAP_PROJECTS.ACTION
})
